import { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { IApiConfigs } from "@swiggy-private/portal-dineout-context";
import { createPopupCard } from "../Menu/helper";

/**
 * Extracts popup cards from API configs without frequency capping.
 * This is a simple extraction - no frequency capping logic is applied.
 *
 * @param configs - API configs containing POPUP configuration
 * @returns Array of popup cards ready to be rendered
 */
export const getPopupCards = (configs: IApiConfigs | undefined): IPLWidgetControllerCards[] => {
    if (!configs?.POPUP?.configInfo) {
        return [];
    }

    const popupCards: IPLWidgetControllerCards[] = [];

    for (const configInfo of configs.POPUP.configInfo) {
        const popup = createPopupCard(configInfo.card);
        if (popup) {
            popupCards.push(popup);
        }
    }

    return popupCards;
};

/**
 * Combines regular cards with popup cards extracted from configs.
 *
 * @param cards - Regular widget cards
 * @param configs - API configs containing POPUP configuration
 * @returns Combined array of regular and popup cards
 */
export const combineCardsWithPopup = (
    cards: IPLWidgetControllerCards[],
    configs: IApiConfigs | undefined
): IPLWidgetControllerCards[] => {
    const popupCards = getPopupCards(configs);
    return popupCards.length > 0 ? [...cards, ...popupCards] : cards;
};
